import { useEffect, useState } from "react";
import { Calendar } from "lucide-react";
import { Button } from "./ui/button";
import { trackCtaClick } from "@/lib/analytics";

const StickyBookingBar = () => {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    let lastY = window.scrollY;
    let ticking = false;

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        const y = window.scrollY;
        const delta = y - lastY;
        if (Math.abs(delta) > 6) {
          // Always show near the top
          if (y < 80) setHidden(false);
          else setHidden(delta > 0);
          lastY = y;
        }
        ticking = false;
      });
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 bg-[hsl(0,0%,5%)]/95 backdrop-blur-sm border-t border-[hsl(38,20%,22%)] py-3 transition-transform duration-300 ${
        hidden ? "translate-y-full" : "translate-y-0"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 flex items-center justify-center">
        <a
          href="https://booking.roomraccoon.co.za/zwahili-game-lodge/en/"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackCtaClick("Book Direct", "sticky_bar")}
        >
          <Button variant="gold" size="sm" className="text-xs tracking-widest gap-2">
            <Calendar size={14} aria-hidden="true" />
            <span className="sm:hidden">Book Direct</span>
            <span className="hidden sm:inline">Book Direct | Best Price Guarantee</span>
          </Button>
        </a>
      </div>
    </div>
  );
};

export default StickyBookingBar;
